import type { SVGProps } from 'react';

const SvgFreeHeartMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.95 4C5.21619 4 3 6.29558 3 9.12728C3 14.2546 8.85 18.9157 12 20C15.15 18.9157 21 14.2546 21 9.12728C21 6.29558 18.7838 4 16.05 4C14.3759 4 12.8958 4.86087 12 6.17853C11.1042 4.86087 9.62413 4 7.95 4Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.5 9H14.5C15.6046 9 16.5 9.89543 16.5 11V12C16.5 13.1046 15.6046 14 14.5 14H13.5V9Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinejoin='round'
    />
    <path
      d='M11.5 14L9.68796 9.01689C9.62413 8.84135 9.37587 8.84135 9.31204 9.01689L7.5 14'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M8 12.5H11' stroke='currentColor' strokeWidth={1.5} />
  </svg>
);
export default SvgFreeHeartMd;
